import _ from 'lodash';
import Axios from 'utils/axios';
import { parseString } from 'xml2js';
import colorcolor from 'colorcolor';

function convertBase64UrlToBlob(str) {
    /^data:(image\/\w+);base64,(.*)$/.test(str);
    var type = RegExp.$1;
    var content = RegExp.$2;
    var bytes = atob(content);
    var ab = new ArrayBuffer(bytes.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    var filename = type.startsWith('image/') ? 'file.' + type.slice(6) : 'file';
    return new File([ab], filename, { type });
}

async function uploadBase64(str) {
    return new Promise(resolve => {
        let formData = new FormData();
        const file = convertBase64UrlToBlob(str);
        formData.append('file', file);
        Axios.post('/admin/upload', formData, {
            headers: {
                'Content-type': 'multipart/form-data'
            }
        }).then(res => {
            resolve(res.url[0]);
        });
    });
}

async function parseSVG(node, list) {
    if (!node) return null;
    for (var key in node) {
        if (key === 'text') {
            for (var t in node[key]) {
                var text = node[key][t];
                var x = parseInt(text.$.x || 0),
                    y = parseInt(text.$.y || 0),
                    width = 0,
                    height = 0;
                var content = '',
                    fontSize = +(text.$['font-size'] || 14),
                    rotate = 0;
                if (
                    text.$.transform &&
                    /rotate\(([-\d\.]+)\)/.test(text.$.transform)
                ) {
                    rotate = +RegExp.$1;
                }
                if (text.tspan) {
                    for (var i in text.tspan) {
                        content += text.tspan[i]._;
                    }
                    if (!x && !y) {
                        x = parseInt(text.tspan[0].$.x);
                        y = parseInt(text.tspan[0].$.y) - fontSize;
                    }
                }
                height = fontSize * 1.5;
                width = fontSize * content.length;
                list.push({
                    type: 'text',
                    rotate: rotate,
                    isDynamic: 0,
                    isCover: 0,
                    content: content,
                    minPoint: {
                        x: parseInt(x),
                        y: parseInt(y)
                    },
                    maxPoint: {
                        x: parseInt(x + width),
                        y: parseInt(y + height)
                    },
                    width: parseInt(width),
                    height: parseInt(height),
                    style: {
                        color: text.$.fill ? colorcolor(text.$.fill) : '',
                        fontSize: fontSize,
                        fontFamily: text.$['font-family']
                    }
                });
            }
        } else if (key === 'image') {
            for (var im in node[key]) {
                var image = node[key][im];
                const width = parseInt(image.$.width);
                const height = parseInt(image.$.height);
                const x = parseInt(image.$.x || 0);
                const y = parseInt(image.$.y || 0);
                var rotate = 0;
                if (
                    image.$.transform &&
                    /rotate\(([-\d\.]+)\)/.test(image.$.transform)
                ) {
                    rotate = +RegExp.$1;
                }
                list.push({
                    type: 'image',
                    rotate: rotate,
                    isDynamic: 0,
                    isCover: 0,
                    minPoint: {
                        x,
                        y
                    },
                    maxPoint: {
                        x: x + width,
                        y: y + height
                    },
                    width,
                    height,
                    content: image.$['xlink:href'].startsWith('data:')
                        ? await uploadBase64(image.$['xlink:href'])
                        : image.$['xlink:href']
                });
            }
        } else if (node[key] && node[key].length) {
            for (var i in node[key]) {
                if (typeof node[key][i] === 'object') {
                    await parseSVG(node[key][i], list);
                }
            }
        }
    }
    return list;
}

export async function convertSVG(content) {
    return new Promise(resolve => {
        parseString(content, async function (err, result) {
            const svg = result.svg;
            const width = parseInt(svg.$.width),
                height = parseInt(svg.$.height);
            let list = [];
            const json = await parseSVG(svg, list);
            console.log(json);
            resolve({
                width: width,
                height: height,
                list: json
            });
        });
    });
}

export function convertJSON(content) {
    console.log(content);
    const start = `<svg width="${content.width}" height="${
        content.height
        }" viewBox="0 0 ${content.width} ${content.height}">`;
    const end = `</svg>`;
    let list = [];
    for (var i in content.list) {
        const comp = content.list[i];
        const x = comp.minPoint.x || 0;
        const y = comp.minPoint.y || 0;
        const max_x = comp.maxPoint.x || 0;
        const max_y = comp.maxPoint.y || 0;
        const width = max_x - x;
        const height = max_y - y;
        const rotate = comp.rotate || 0;
        if (comp.type === 'image') {
            const url = comp.content;
            list.push(`
<g class="transform" transform="translate(${x}, ${y}) rotate(${rotate}, ${width /
                2}, ${height / 2})">
	<g class="anchor">
		<svg width="${width}" height="${height}">
			<image xlink:href="${url}" width="${width}" height="${height}"></image>
		</svg>
    </g>
</g>
`);
        } else if (comp.type === 'text') {
            list.push(`
<g class="transform" transform="translate(${x}, ${y}) rotate(${rotate}, ${width /
                2}, ${height / 2})">
	<g class="anchor">
		<svg width="${width}" height="${height}">
			<rect width="${width}" height="${height}" opacity="0"></rect>
			<text text-anchor="start" dominant-baseline="text-before-edge" line-height="1"
				  fill="${comp.style.color}"
				  font-family="${comp.style.fontFamily}"
				  font-size="${comp.style.fontSize}"
			>${comp.content}</text>
		</svg>
    </g>
</g>
`);
        }
    }

    return start + list.join('\n') + end;
}

export function copyText(text) {
    console.log('======复制链接======');
    var input = document.createElement('textarea');
    input.value = text;
    input.style.opacity = '0';
    input.style.position = 'absolute';
    input.style.left = '-9999999';
    document.body.appendChild(input);
    input.focus();
    input.setSelectionRange(0, input.value.length);
    var save = function (e) {
        e.clipboardData.setData('text/plain', text); //下面会说到clipboardData对象
        e.preventDefault(); //阻止默认行为
    };
    document.addEventListener('copy', save);
    document.execCommand('copy', false, null);
    input.remove();
    document.removeEventListener('copy', save);
}

export function isMac() {
    return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
}
